import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

export default function CGUPage() {
    const lastUpdate = "29 septembre 2026";

    const sections = [
        {
            id: "resume",
            title: "Résumé rapide",
            content:
                "Cette plateforme est destinée à la promotion d’événements familiaux, culturels, sportifs et artistiques. Les règles ci-dessous visent à garantir un espace sûr, conforme à la loi française et adapté à tous les publics.",
        },
        {
            id: "types",
            title: "1. Types d’événements autorisés",
            content: [
                "Événements familiaux (mariages, anniversaires, fêtes locales, rassemblements associatifs)",
                "Événements culturels : expositions, ateliers créatifs, conférences, salons, lectures publiques",
                "Activités sportives et compétitions non liées à des paris (tournois scolaires, clubs amateurs, démonstrations sportives)",
                "Tournois de jeux (échecs, jeux vidéo) sans mise d’argent",
                "Catégorie cinéma : projections de films, courts-métrages, festivals de cinéma, soirées ciné, avant-premières (dans le respect de la législation)",
                "Spectacles vivants : théâtre, danse, comédies musicales, stand-up, cirque",
                "Concerts, showcases et événements musicaux respectant les lois et autorisations locales",
                "Événements éducatifs et communautaires : formations, sensibilisations, rencontres citoyennes, actions solidaires",
                "Marchés, foires et événements commerciaux autorisés par la réglementation locale",
            ],
        },

        {
            id: "interdits",
            title: "2. Contenus interdits",
            content: [
                "Contenu à caractère sexuel explicite",
                "Événements impliquant des jeux d’argent, paris ou loteries illégales",
                "Promotion ou incitation à la violence, discours de haine ou discrimination",
                "Promotion de substances illicites ou activités illégales",
            ],
        },
        {
            id: "publication",
            title: "3. Conditions pour publier",
            content: [
                "Description claire et honnête de l’événement (date, lieu, tarif).",
                "Images et vidéos appropriées pour le public général.",
                "Coordonnées valides de l’organisateur (nom, email, téléphone).",
                "Respect des lois et règlements locaux (sécurité, autorisations).",
            ],
        },
        {
            id: "responsabilite",
            title: "4. Responsabilité & modération",
            content: [
                "La plateforme se réserve le droit de refuser ou supprimer toute annonce non conforme.",
                "L’organisateur est responsable légalement de l’événement et de la sécurité des participants.",
                "Les frais d’inscription ou d’abonnement peuvent ne pas être remboursés si l’annonce est supprimée pour non-respect des règles.",
                "Signalement possible par les utilisateurs (bouton « Signaler »).",
            ],
        },
        {
            id: "public",
            title: "5. Public cible",
            content:
                "Plateforme adaptée à tous publics. Seules les personnes âgées de 15 ans ou plus peuvent publier des événements ; les événements peuvent être destinés à des mineurs si conformes à la loi.",
        },

        {
            id: "moderation",
            title: "6. Procédure de modération",
            content: [
                "Vérification automatique (mots-clés, filtres d’images).",
                "Revue manuelle pour les cas signalés.",
                "Avertissement à l’organisateur en cas d’infraction mineure.",
                "Suppression et blocage en cas de récidive ou infraction grave.",
            ],
        },
        {
            id: "billetterie-organisateurs",
            title: "7. Billetterie Thrundrz — organisateurs",
            content: [
                "Pour vendre des billets, l'organisateur doit ouvrir un compte de paiement auprès de Stripe via Stripe Connect, depuis son espace « Ma Billetterie ». Stripe vérifie son identité et ses coordonnées bancaires ; ces informations sont conservées par Stripe et ne sont pas accessibles à Thrundrz.",
                <>
                    En activant ses paiements, l'organisateur accepte le{" "}
                    <a href="https://stripe.com/fr/legal/connect-account" target="_blank" rel="noopener noreferrer" className="text-color6 underline hover:text-color3">
                        Contrat de compte connecté Stripe
                    </a>
                    , qui inclut les{" "}
                    <a href="https://stripe.com/fr/legal/ssa" target="_blank" rel="noopener noreferrer" className="text-color6 underline hover:text-color3">
                        Conditions générales de Stripe
                    </a>
                    . L'organisateur autorise Thrundrz à transmettre à Stripe les informations le concernant et concernant ses ventes.
                </>,
                "Tant que le compte de paiement n'est pas validé par Stripe, la vente de billets payants est bloquée ; les événements gratuits restent réservables.",
                "Les sommes payées par les acheteurs sont conservées par Stripe. La part revenant à l'organisateur (prix des billets, déduction faite des éventuels frais indiqués dans son espace) lui est transférée via Stripe Connect entre 7 et 15 jours après la date de l'événement, puis versée sur son compte bancaire selon les délais de Stripe.",
                "Ce délai permet de traiter les annulations, remboursements et contestations de paiement. Thrundrz peut suspendre un versement en cas de litige, de fraude suspectée ou d'annulation de l'événement.",
                "L'organisateur reste seul responsable de son événement et de sa tenue. S'il annule une réservation (manque de places, erreur…), l'acheteur est remboursé du montant payé, frais de service compris, à l'exception des frais de paiement Stripe, qui ne sont pas restitués par Stripe ; la part de l'organisateur est reprise sur son compte de paiement.",
                "Dès qu'au moins une réservation existe, l'organisateur ne peut plus modifier lui-même la date, l'horaire, le lieu, les tarifs ni le mode de billetterie, ni annuler l'événement. Il doit adresser une demande motivée à Thrundrz depuis son espace. Thrundrz examine la demande, prévient les acheteurs et, en cas d'annulation, les rembourse selon les règles ci-dessus. En cas de report, les acheteurs qui ne peuvent pas venir à la nouvelle date peuvent demander le remboursement.",
                "Chaque annulation par l'organisateur est enregistrée avec son motif. En cas d'annulations répétées ou abusives, Thrundrz peut lui refacturer les frais de paiement engagés, suspendre sa billetterie ou son compte.",
                "Lorsqu'un acheteur annule lui-même sa réservation (jusqu'à 24 heures avant l'événement), il est remboursé du prix du billet ; les frais de service Thrundrz et les frais de paiement Stripe ne sont pas remboursés. Le billet annulé n'est pas compté dans le versement de l'organisateur.",
                "L'organisateur est responsable de ses propres obligations fiscales et déclaratives sur les recettes perçues.",
            ],
        },
        {
            id: "billetterie-acheteurs",
            title: "8. Achat de billets — participants",
            content: [
                "Le paiement est réalisé par carte bancaire via Stripe, prestataire agréé. Thrundrz n'a jamais accès aux données de carte.",
                "Le prix total, incluant le prix du billet fixé par l'organisateur et les éventuels frais de service, est affiché avant la validation du paiement.",
                "Le billet (avec QR code) est disponible dans l'espace « Mes réservations » dès la confirmation du paiement. Il est contrôlé à l'entrée par l'organisateur ou son équipe.",
                "Conformément à l'article L221-28 12° du Code de la consommation, le droit de rétractation ne s'applique pas aux billets d'activités de loisirs fournies à une date déterminée.",
                "Annulation par l'acheteur : l'acheteur peut annuler sa réservation depuis l'application jusqu'à 24 heures avant le début de l'événement. Il est alors remboursé du prix du billet ; les frais de service Thrundrz et les frais de paiement Stripe, déjà engagés, ne sont pas remboursés. Passé ce délai, aucune annulation ni remboursement n'est possible.",
                "Changement de nom : jusqu'à 24 heures avant le début de l'événement, l'acheteur peut transférer son billet à une autre personne. Un nouveau QR code est généré et l'ancien n'est plus valable.",
                "Billet gratuit : l'annulation libère simplement la place, jusqu'à 24 heures avant l'événement.",
                "Annulation par l'organisateur (événement annulé ou réservation annulée) : l'acheteur est prévenu par e-mail et remboursé du montant payé, frais de service compris. Les frais de paiement sécurisé, retenus par Stripe et non restitués par celui-ci, restent à la charge de l'acheteur dans tous les cas.",
                "Report ou modification importante de l'événement (date, lieu) : l'acheteur est prévenu par e-mail et peut demander le remboursement de son billet s'il ne peut pas y assister, dans les mêmes conditions.",
                "Le remboursement est effectué sur la carte utilisée lors de l'achat, via Stripe ; le délai d'apparition sur le compte dépend de la banque de l'acheteur.",
            ],
        },
        {
            id: "contact",
            title: "9. Contact & support",
            content: (
                <>
                    Pour questions ou signalements :{" "}
                    <a
                        href="mailto:contact@thrundrz.fr"
                        className="text-color6 underline hover:text-color3"
                    >
                        contact@thrundrz.fr
                    </a>
                </>
            ),
        },
    ];

    return (
        <>
            <Helmet>
                <title>Conditions générales d'utilisation — Thrundrz</title>
                <meta name="description" content="Consultez les conditions générales d'utilisation de Thrundrz : règles de publication, événements autorisés, responsabilités et modération." />
                <link rel="canonical" href="https://thrundrz.fr/cgu" />
            </Helmet>
            <Navbar />
            <main className="min-h-screen bg-black text-white font-archivo lg:pt-20 pt-10">
                <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-12">
                    {/* En-tête */}
                    <header className="mb-12 text-start">
                        <div className="flex items-center gap-3 mb-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                fill="currentColor"
                                className="text-color6"
                                viewBox="0 0 16 16"
                            >
                                <path d="M11 6.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5z" />
                                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h.5A1.5 1.5 0 0 1 15 2.5v10A1.5 1.5 0 0 1 13.5 14H2.5A1.5 1.5 0 0 1 1 12.5v-10A1.5 1.5 0 0 1 2.5 1H3v-.5A.5.5 0 0 1 3.5 0zM2 4v8.5a.5.5 0 0 0 .5.5H13.5a.5.5 0 0 0 .5-.5V4H2z" />
                            </svg>
                            <div>
                                <h1 className="text-3xl sm:text-4xl font-bold text-color6">
                                    Conditions générales
                                </h1>

                            </div>
                        </div>
                        <small className="text-gray-400">
                            Règles générales & conditions de publication
                        </small>
                        <p className="text-sm sm:text-base text-gray-400 font-thin">
                            Dernière mise à jour : {lastUpdate}
                        </p>
                    </header>

                    {/* Sommaire */}
                    <nav
                        aria-label="Sommaire"
                        className="mb-10 rounded-2xl border border-color6 p-6 shadow-sm font-archivo bg-[#111]"
                    >
                        <h2 className="text-lg font-semibold text-color6 mb-4">Sommaire</h2>
                        <ul className="grid gap-3 sm:grid-cols-2">
                            {sections.map((s) => (
                                <li key={s.id}>
                                    <a
                                        href={`#${s.id}`}
                                        className="text-sm sm:text-base text-gray-300 hover:text-color6 hover:underline"
                                    >
                                        {s.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Contenu */}
                    <div className="space-y-12">
                        {sections.map((s) => (
                            <section key={s.id} id={s.id}>
                                <h3 className="text-2xl sm:text-3xl font-bold text-color6 mb-4 text-start">
                                    {s.title}
                                </h3>

                                {Array.isArray(s.content) ? (
                                    <ul className="list-disc pl-6 space-y-2 text-gray-200 text-base sm:text-lg">
                                        {s.content.map((item, i) => (
                                            <li key={i}>{item}</li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="text-gray-200 text-base sm:text-lg leading-relaxed text-justify">
                                        {s.content}
                                    </p>
                                )}
                            </section>
                        ))}
                    </div>

                    {/* Footer */}
                    <footer className="text-center text-gray-500 text-sm mt-16">
                        © {new Date().getFullYear()} Thrundrz — Tous droits réservés.
                    </footer>
                </div>
            </main>
            <Footer />
        </>
    );
}